const handler = ( $ ) => {
	const filterId = 'ws-taxonomy-filter',
		filterAncor = `#!/${ filterId }`,
		$filter = $( `#${ filterId }` ),
		$filterSelect = $( 'select', $filter );

	if ( $filterSelect.length == 0 ) {
		return;
	}

	// Selectric
	$filterSelect.selectric( {
		responsive: true,
		maxHeight: 368,
	} );

	// Selectric Change Handler
	const filterSelectChangesHandler = function ( event, element, selectric ) {
		const $select = $( this ),
			selectedTaxSlug = $select.val(),
			mainUrlPath = $select.data( 'main-url-path' ),
			taxUrlPath = $select.data( 'tax-url-path' ),
			currentPageUrl = `${ window.location.protocol }//${ window.location.host }/${ mainUrlPath }/`;

		let newUrl = `${ currentPageUrl }${ filterAncor }`;

		if ( selectedTaxSlug != 'all' ) {
			newUrl = `${ currentPageUrl }${ taxUrlPath }/${ selectedTaxSlug }/${ filterAncor }`;
		}

		window.location.replace( newUrl );
	};

	$filterSelect.on( 'selectric-change', filterSelectChangesHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
